import React, { useEffect, useState } from "react";
import MainTextArea from "components/MainApp/atoms/Forms/MainTextArea";
import imageFile from "assets/images/image-placeholder.png";

import styles from "./EditCodeTagForm.module.scss";
import { capitalize } from "helpers/utils/utils_general";
import i18n from "i18n";

const EditCodeTagForm = ({
  configTag,
  handleClickVisualize,
  onConfigTagChange,
  imageSrc,
  error
}) => {
  const [editCondigTag, setEditConfigTag] = useState();
  const [code, setCode] = useState();

  useEffect(() => {
    if (configTag) {
      const type = getTypeOrId(configTag.type);
      setEditConfigTag(configTag);
      setCode(configTag.zplFormat);
    }
  }, [configTag]);

  const getTypeOrId = type => {
    if (type?.id) {
      return type.id;
    }
    return type;
  };

  const handleVisualizeClick = () => {
    handleClickVisualize(code);
  };

  const handleInputChange = (e) => {
    configTag.zplFormat = e.target.value;
    onConfigTagChange(configTag);
    setCode(e.target.value);
};

  return (
    <div className={styles["edit-tag-form-content"]}>
      <div className={styles["edit-tag-form-panel-left"]}>
        <div className={styles["edit-tag-form-image"]}>
          <img
            src={imageSrc || imageFile}
            alt="tag"
          />
        </div>
        <div>
          <label className={styles["edit-code-tag-label-error"]}>{error}</label>
        </div>
      </div>
      <div className={styles["edit-tag-form-panel-right"]}>
        <div className={styles["edit-tag-form-field"]} data-automation-id="input-code">
          <MainTextArea
            id={"edit-tag-code"}
            name={"code"}
            handleChange={handleInputChange}
            maxLength={5000}
            value={code || ""}
          ></MainTextArea>
        </div>
      </div>
    </div>
  );
};

export default EditCodeTagForm;
